import React from 'react';
import { I18nProvider } from './components/I18nProvider';
import { PromptEditor } from './components/PromptEditor';

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <PromptEditor />
      </div>
    </I18nProvider>
  );
}

export default App;
